import { readAttemptProjectReferences } from '@/challenges/attemptProjectReferences';

/** Home keeps uncertain records visible for local recovery. Sharing must fail closed. */
export async function assertProjectSharePrivacy(
  name: string,
  mainChipId: string,
  signal?: AbortSignal,
): Promise<void> {
  signal?.throwIfAborted();
  if (!mainChipId) throw new Error('Unable to verify this project is safe to share.');
  let references: Awaited<ReturnType<typeof readAttemptProjectReferences>>;
  try {
    references = await readAttemptProjectReferences();
  } catch {
    throw new Error(
      'Unable to verify challenge attempt privacy. Repair the local challenge history before sharing. Local export remains available.',
    );
  }
  signal?.throwIfAborted();
  if (
    references.some(
      (reference) => reference.project === name && reference.mainChipId === mainChipId,
    )
  ) {
    throw new Error(
      'Private challenge attempts cannot be shared as public project links.',
    );
  }
}
